module.exports = __webpack_public_path__ + "img/e-bannerespa_2.80a6642d.png";